import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { PiChatTeardropDotsFill, PiPaperPlaneRight } from 'react-icons/pi';
import './styles.css';

const NaraAssistantLauncher = ({ onOpen }) => {
  const [draft, setDraft] = useState('');
  const open = useCallback((event) => { event?.preventDefault(); onOpen(draft.trim()); setDraft(''); }, [draft, onOpen]);
  return <form className="nara-launcher" onSubmit={open} aria-label="Abrir Nara Assistant">
    <button type="button" className="nara-launcher__identity" onClick={open} aria-label="Abrir Nara Assistant"><PiChatTeardropDotsFill /></button>
    <input value={draft} maxLength="500" onChange={(event) => setDraft(event.target.value)} placeholder="Conte algo para a Nara..." aria-label="Mensagem inicial para a Nara" />
    <button type="submit" className="nara-launcher__send" aria-label={draft.trim() ? 'Levar mensagem para a Nara' : 'Abrir Nara Assistant'}><PiPaperPlaneRight /></button>
  </form>;
};

NaraAssistantLauncher.propTypes = { onOpen: PropTypes.func.isRequired };
export default NaraAssistantLauncher;
